/**
 * @generated SignedSource<<cd230eb5d03aec0ac003a4f6a6ca20cc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "comments"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "versionId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "comments",
        "variableName": "comments"
      },
      {
        "kind": "Variable",
        "name": "versionId",
        "variableName": "versionId"
      }
    ],
    "concreteType": "BasicMutationResponse",
    "kind": "LinkedField",
    "name": "updateReviewComments",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateReviewCommentsMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "UpdateReviewCommentsMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4eee4f5e2faf5a16a8126580fa32ae95",
    "id": null,
    "metadata": {},
    "name": "UpdateReviewCommentsMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateReviewCommentsMutation(\n  $versionId: ID!\n  $comments: String!\n) {\n  updateReviewComments(versionId: $versionId, comments: $comments) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "8966b96a52975289f11211f8248b2cda";

export default node;
